export default __webpack_public_path__ + "static/tab-img-207108977d501cd6092a4b42ac80dfcc.png";